import "./App.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { Session } from "@supabase/supabase-js";
import { supabase } from "@/integrations/supabase/client";
import Index from "./pages/Index";
import Status from "./pages/Status";
import Pricing from "./pages/Pricing";
import Auth from "./pages/Auth";
import Documentation from "./pages/Documentation";
import Support from "./pages/Support";
import Dashboard from "./pages/Dashboard";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => {
  const [session, setSession] = useState<Session | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Get initial session
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      setIsLoading(false);
    });

    // Listen for auth changes
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    });

    return () => subscription.unsubscribe();
  }, []);

  if (isLoading) {
    return null; // or a loading spinner
  }

  return (
    <QueryClientProvider client={queryClient}>
      <div className="app">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Index session={session} />} />
            <Route
              path="/status"
              element={
                session ? (
                  <Status session={session} />
                ) : (
                  <Navigate to="/auth" state={{ from: "/status" }} />
                )
              }
            />
            <Route path="/pricing" element={<Pricing session={session} />} />
            <Route
              path="/auth"
              element={
                !session ? (
                  <Auth />
                ) : (
                  <Navigate to="/dashboard" replace={true} />
                )
              }
            />
            <Route
              path="/documentation"
              element={<Documentation session={session} />}
            />
            <Route
              path="/support"
              element={
                session ? (
                  <Support session={session} />
                ) : (
                  <Navigate to="/auth" state={{ from: "/support" }} />
                )
              }
            />
            <Route
              path="/dashboard"
              element={
                session ? (
                  <Dashboard session={session} />
                ) : (
                  <Navigate to="/auth" state={{ from: "/dashboard" }} />
                )
              }
            />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </div>
    </QueryClientProvider>
  );
};

export default App;